import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M3 4.29C3 3.576 3.592 3 4.322 3h15.356C20.408 3 21 3.577 21 4.29v15.42c0 .713-.592 1.29-1.322 1.29H4.322C3.592 21 3 20.423 3 19.71V4.29Zm5.56 13.778V9.94h-2.7v8.128h2.7ZM7.21 8.83c.942 0 1.529-.623 1.529-1.404-.017-.798-.585-1.404-1.51-1.404S5.7 6.629 5.7 7.426c0 .78.586 1.404 1.493 1.404h.018Zm5.522 9.238v-4.54c0-.242.018-.485.09-.658.195-.485.64-.988 1.386-.988.978 0 1.368.745 1.368 1.838v4.348h2.701v-4.662c0-2.497-1.332-3.658-3.109-3.658-1.433 0-2.076.787-2.436 1.342v.028h-.018l.018-.028V9.94h-2.7c.034.763 0 8.128 0 8.128h2.7Z"
    />
  </svg>
`;
